import { useState, useContext } from "react";
import {
  TextField, Button, Paper, Typography, Box, Checkbox, FormControlLabel, IconButton
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, Link } from "react-router-dom";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { ColorModeContext } from "../ThemeContext";
import { login } from "../api/api";

export default function Login() {
  const [usernameOrEmail, setUsernameOrEmail] = useState(localStorage.getItem("rememberedUser") || "");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [remember, setRemember] = useState(!!localStorage.getItem("rememberedUser"));
  const navigate = useNavigate();
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);

  const isDark = theme.palette.mode === "dark";
  const paperBg = isDark ? "#23272f" : "#fff";
  const textColor = isDark ? "#fff" : "#23272f";

  const handleLogin = async (e) => {
    e.preventDefault();
    setMsg("");
    try {
      const res = await login(usernameOrEmail, password);
      localStorage.setItem("token", res.data.token);
      if (remember) {
        localStorage.setItem("rememberedUser", usernameOrEmail);
      } else {
        localStorage.removeItem("rememberedUser");
      }
      navigate("/dashboard");
    } catch (err) {
      setMsg(
        err.response?.data?.error || "Usuário, e-mail ou senha inválidos."
      );
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: { xs: 3, sm: 4 },
          width: { xs: 320, sm: 370 },
          maxWidth: "95vw",
          borderRadius: 4,
          bgcolor: paperBg,
          color: textColor,
          position: "relative",
          boxShadow: 6,
        }}
      >
        {/* Botão tema claro/escuro */}
        <IconButton
          size="small"
          onClick={colorMode.toggleColorMode}
          sx={{ position: "absolute", top: 13, right: 13 }}
        >
          {isDark ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
        {/* Logo centralizada */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <img
            src="/iseq3.png"
            alt="iSEQ - Sensores & Instrumentos"
            style={{
              height: 78,
              maxWidth: "85%",
              marginBottom: 12,
              objectFit: "contain",
              filter: isDark ? "brightness(0.94)" : "none"
            }}
          />
        </Box>
        <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 700 }}>
          Login
        </Typography>
        <form onSubmit={handleLogin} autoComplete="on">
          <TextField
            fullWidth
            label="Usuário ou E-mail"
            margin="normal"
            value={usernameOrEmail}
            onChange={e => setUsernameOrEmail(e.target.value)}
            required
            autoFocus
            autoComplete="username"
            InputProps={{
              sx: { color: textColor }
            }}
            InputLabelProps={{
              sx: { color: theme.palette.text.secondary }
            }}
          />
          <TextField
            fullWidth
            label="Senha"
            margin="normal"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            InputProps={{
              sx: { color: textColor }
            }}
            InputLabelProps={{
              sx: { color: theme.palette.text.secondary }
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={remember}
                onChange={e => setRemember(e.target.checked)}
                color="primary"
              />
            }
            label="Lembrar usuário/e-mail"
            sx={{ mt: -1 }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 2, mb: 1.5, fontWeight: 600, fontSize: 17 }}
          >
            Entrar
          </Button>
        </form>
        <Typography variant="body2" align="center" sx={{ mt: 1.5 }}>
          Não tem conta?{" "}
          <Link to="/register" style={{ color: theme.palette.primary.main, fontWeight: 500 }}>Cadastre-se</Link>
        </Typography>
        <Typography variant="body2" align="center" sx={{ mt: 1 }}>
          <Link to="/forgot-password" style={{ color: theme.palette.primary.main, fontWeight: 500 }}>
            Esqueci minha senha
          </Link>
        </Typography>
        {msg && (
          <Typography color="error" align="center" sx={{ mt: 2, fontWeight: 500 }}>
            {msg}
          </Typography>
        )}
      </Paper>
    </Box>
  );
}

